import { useContext, useEffect, useState } from "react"
import { api } from "../../../api/api"
import { Toast } from "../../../utils/Toast"
import { MenuContext } from "../../../context/MenuContext"
import "../menu-form.css"

const DEFAULT_CATEGORY = {
  id: null,
  name: "",
  isLocal: false,
  isMenu: false,
  active: false,
}

export function CategoryModal() {
  const { load, categoryEdit, setCategoryEdit } = useContext(MenuContext)

  const [state, setState] = useState(DEFAULT_CATEGORY)

  useEffect(() => {
    if (categoryEdit.id)
      setState({
        id: categoryEdit.id,
        name: categoryEdit.name,
        isLocal: categoryEdit.isLocal,
        isMenu: categoryEdit.isMenu,
        active: Boolean(categoryEdit.active)
      })
  }, [categoryEdit])

  function clear() {
    setState(DEFAULT_CATEGORY)
    setCategoryEdit({})
  }

  async function created(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('O campo nome é obrigatório')
    }

    const response = await api.post("/category", state)
    const { id } = response.data
    setState({
      ...state,
      id
    })
    await load()
    Toast.success()
    clear()
    return id
  }

  async function updated(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('O campo nome é obrigatório')
    }

    const response = await api.put("/category/" + state.id, state)
    const { id } = response.data
    setState({
      ...state,
      id
    })

    await load()
    Toast.success()
    clear()
    return id
  }

  return (
    <>
      <div className="modal fade admin-form-modal menu-entity-modal" id="modalCategory" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="categoryModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div><h5 className="modal-title" id="categoryModalLabel">{state.id ? 'Editar categoria' : 'Nova categoria'}</h5><p>Organize os produtos exibidos no cardápio</p></div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clear()}></button>
            </div>
            <div className="modal-body">
              <form className="menu-modal-form">
                <div>
                  <label htmlFor="category-name">Nome da categoria</label>
                  <input type="text" maxLength={255} value={state.name} onChange={(e) => setState({
                    ...state,
                    name: e.target.value
                  })} id="category-name" aria-describedby="category-name-help" />
                  <small id="category-name-help">Este nome será exibido no cardápio.</small>
                </div>
                <div className="menu-modal-options">
                  <label className="menu-modal-check" htmlFor="category-local">
                    <input type="checkbox" checked={state.isLocal} onChange={(e) => setState({
                      ...state,
                      isLocal: e.target.checked
                    })} id="category-local" /> Venda local
                  </label>
                  <label className="menu-modal-check" htmlFor="category-delivery">
                    <input type="checkbox" checked={state.isMenu} onChange={(e) => setState({
                      ...state,
                      isMenu: e.target.checked
                    })} id="category-delivery" /> Delivery
                  </label>
                  <label className="menu-modal-check" htmlFor="category-active">
                    <input type="checkbox" checked={state.active} onChange={(e) => setState({
                      ...state,
                      active: e.target.checked
                    })} id="category-active" /> Categoria ativa
                  </label>
                </div>
              </form>
              <div className="menu-modal-actions"><button type="button" className="admin-primary-button" onClick={state.id ? updated : created}>Salvar categoria</button></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
